/* unplugin-vue-components disabled */import { ElForm as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElButton as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElInput as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import __unplugin_components_1 from '/Users/zpw/Documents/hero/ultrasdk.hub.web/packages/base/src/components/GameChannelSelect/index.vue';
import { ElFormItem as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索");
const _hoisted_2 = /*#__PURE__*/_createTextVNode("导出数据");
import DateRangePicker from '@ultra/share/components/DateRangePicker/index.vue';
import CTable from '@ultra/share/components/CTable/index.vue';
import { useAppStore } from '@/store/modules/app';
import { apiGlobalRefundOrderList } from '@/api/global';
import { useTaskStore } from '@/store/modules/downTask';
import dayjs from 'dayjs';
export default /*#__PURE__*/_defineComponent({
  setup(__props) {
    const gameInfo = computed(() => useAppStore().gameInfo);
    const {
      setTask
    } = useTaskStore();
    const filter = ref({
      gid: '',
      cids: undefined,
      productId: '',
      payType: '',
      suid: '',
      uid: '',
      deviceId: '',
      hgOrderNo: '',
      thirdOrder: '',
      roleId: '',
      roleName: ''
    });
    const orderDate = ref({
      startDate: dayjs().subtract(7, 'days').format('YYYY-MM-DD'),
      endDate: dayjs().format('YYYY-MM-DD')
    });
    const columns = [{
      label: 'ID',
      prop: 'id',
      isForce: true,
      isDefault: true
    }, {
      label: '渠道',
      prop: 'projectName',
      isDefault: true
    }, {
      label: 'UltraSDKID',
      prop: 'uid'
    }, {
      label: '角色账号ID',
      prop: 'suid'
    }, {
      label: '产品名称',
      prop: 'productName',
      isDefault: true
    }, {
      label: '区服名称',
      prop: 'serverName',
      isDefault: true
    }, {
      label: '游戏角色ID',
      prop: 'roleId',
      isDefault: true
    }, {
      label: '角色名称',
      prop: 'roleName',
      isDefault: true
    }, {
      label: '设备号',
      prop: 'deviceId'
    }, {
      label: '档位',
      prop: 'channelGoodsId'
    }, {
      label: '币种',
      prop: 'oriCurrency'
    }, {
      label: '退款金额',
      prop: 'oriAmount',
      isDefault: true
    }, {
      label: '道具名称',
      prop: 'propName',
      isDefault: true
    }, {
      label: '退款时间',
      prop: 'voidedTime',
      isDefault: true
    }, {
      label: '退款方式',
      prop: 'payTypeName'
    }, {
      label: 'Ultra订单号',
      prop: 'hgOrderNo',
      isDefault: true
    }, {
      label: '第三方订单号',
      prop: 'thirdOrderNo',
      isDefault: true
    }];
    const tableData = ref([]);
    const tableLoading = ref(false);
    const getTableData = () => {
      tableLoading.value = true;
      let {
        startDate,
        endDate
      } = orderDate.value;
      apiGlobalRefundOrderList({
        startTime: startDate,
        endTime: endDate,
        ...filter.value
      }).then(res => {
        if (res.code === 0) {
          tableData.value = res.data;
        }
      }).finally(() => {
        tableLoading.value = false;
      });
    };
    watch(() => gameInfo.value, val => {
      if (val && val.Id) {
        filter.value.gid = val.Id;
        getTableData();
      }
    }, {
      immediate: true,
      deep: true
    });
    const exportTable = () => {
      let [startTime, endTime] = [orderDate.value.startDate, orderDate.value.endDate];
      setTask({
        api: apiGlobalRefundOrderList,
        page: 'pageNumber',
        pageSize: 'pageSize',
        params: {
          startTime,
          endTime,
          ...filter.value
        },
        data: 'data',
        total: 'total',
        excel: {
          title: `全球退款订单`,
          header: ['ID', '渠道', 'UltraSDKID', '角色账号ID', '产品名称', '区服名称', '游戏角色ID', '角色名称', '设备号', '档位', '币种', '退款金额', '道具名称', '退款时间', '退款方式', 'Ultra订单号', '第三方订单号'],
          field: ['id', 'projectName', 'uid', 'suid', 'productName', 'serverName', 'roleId', 'roleName', 'deviceId', 'channelGoodsId', 'currency', 'amount', 'propName', 'voidedTime', 'payTypeName', 'hgOrderNo', 'thirdOrderNo']
        }
      });
    };
    onMounted(() => {
      getTableData();
    });
    return (_ctx, _cache) => {
      const _component_el_form_item = __unplugin_components_0;
      const _component_GameChannelSelect = __unplugin_components_1;
      const _component_el_input = __unplugin_components_2;
      const _component_el_button = __unplugin_components_3;
      const _component_el_form = __unplugin_components_4;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_form, {
        inline: "",
        class: "marginT20"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "退款时间"
        }, {
          default: _withCtx(() => [_createVNode(DateRangePicker, {
            startValue: orderDate.value.startDate,
            "onUpdate:startValue": _cache[0] || (_cache[0] = $event => orderDate.value.startDate = $event),
            endValue: orderDate.value.endDate,
            "onUpdate:endValue": _cache[1] || (_cache[1] = $event => orderDate.value.endDate = $event),
            valueFormat: "YYYY-MM-DD",
            type: "daterange"
          }, null, 8, ["startValue", "endValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "渠道"
        }, {
          default: _withCtx(() => [_createVNode(_component_GameChannelSelect, {
            modelValue: filter.value.cids,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => filter.value.cids = $event),
            gid: filter.value.gid,
            otherProps: {
              isGlobal: 1
            }
          }, null, 8, ["modelValue", "gid"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "UltraSDKID"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: filter.value.uid,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => filter.value.uid = $event),
            placeholder: "输入UltraSDKID"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "角色账号ID"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: filter.value.suid,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => filter.value.suid = $event),
            placeholder: "输入角色账号ID"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "游戏角色ID"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: filter.value.roleId,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => filter.value.roleId = $event),
            placeholder: "输入游戏角色ID"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "游戏角色名称"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: filter.value.roleName,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => filter.value.roleName = $event),
            placeholder: "输入游戏角色名称"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "Ultra订单号"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: filter.value.hgOrderNo,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => filter.value.hgOrderNo = $event),
            placeholder: "输入Ultra订单号"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "第三方订单号"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: filter.value.thirdOrder,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => filter.value.thirdOrder = $event),
            placeholder: "输入第三方订单号"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "设备号"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: filter.value.deviceId,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => filter.value.deviceId = $event),
            placeholder: "输入设备号"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: getTableData,
            type: "primary"
          }, {
            default: _withCtx(() => [_hoisted_1]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(CTable, {
        tableColumns: columns,
        tableData: tableData.value,
        loading: tableLoading.value
      }, {
        top: _withCtx(() => [_createVNode(_component_el_button, {
          class: "marginL10",
          onClick: exportTable,
          type: "primary"
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }, 8, ["tableData", "loading"])], 64);
    };
  }
});